import type { GetJobUtterancesResponseDto } from 'app/API';
import type { TSearchableWord } from '../types/TSearch';

export const flattenUtteranceWords = (utterances: GetJobUtterancesResponseDto['utterances']): TSearchableWord[] =>
  utterances.flatMap((utterance, utteranceIndex) =>
    utterance.words.flatMap((word, wordIndex) =>
      word.text.trim().length > 0
        ? [
            {
              key: `${utteranceIndex}:${wordIndex}`,
              itemIndex: utteranceIndex,
              text: word.text,
            },
          ]
        : [],
    ),
  );
